<template>
    <b-overlay :show="loading" class="animated">
        <div class="animated">
            <v-server-table
                :columns="table_config.columns"
                :options="table_config.options"
                :theme="theme"
                :ref="ref"
            >
                <span slot="user" slot-scope="{ row }">
                    <a :href="`#/staff/${row.user.id}`">{{ row.user.name }}</a>
                </span>
                <span slot="status" slot-scope="{ row }">
                    <ResultExportStatusBadge :result_export="row" />
                </span>
                <span slot="actions" slot-scope="{ row }">
                    <DownloadResultImportFile :resultImportID="row.id" :isAction="true" />
                </span>
            </v-server-table>
        </div>
    </b-overlay>
</template>
<script>
import Vue from 'vue';
import BaseServerTable from "@/components/shared/BaseServerTable.vue";
import { ServerTable } from "vue-tables-2";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import ResultImportCollection from '@/collections/lab/ResultImportCollection';
import DownloadResultImportFile from './DownloadResultImportFile.vue';
import ResultExportStatusBadge from '../resultexport/ResultExportStatusBadge.vue';

Vue.use(ServerTable);

export default {
    name: "ResultImportServerTable",
    extends: BaseServerTable,
    components: {
    ServerTable,
    DownloadResultImportFile,
    ResultExportStatusBadge
},
    mixins: [ ToastNotifications ],
    props: {
        collection: {
            type: Object,
            default: () => new ResultImportCollection()
        },
        export_id: {
            type: String,
            default: () => null
        },
        show_columns: {
            type: Array,
            default: () => [
                "code",
                "user",
                "status",
                "actions"
            ]
        },
        filterable: {
          type: Array,
          default: () => [],
        },
        sortable: {
          type: Array,
          default: () => [],
        },
        show_filters: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            entity_type: "resultImport",
            table_config: Object.assign(this.getDefaultTableConfig(), {
                options: {
                    headings: {}
                },
                filterable: this.filterable,
                sortable: this.sortable,
                debounce: 300,
            })
        };
    },
    methods: {
        prepareCollectionFilter(filter) {
            filter.filterEquals("result_export_id", this.export_id);

            filter.connectionAdd(['user']);

            return filter;
        }
    }
};
</script>
